import React from "react";
import OwlCarousel from "react-owl-carousel3";
// import "owl.carousel/dist//owl.carousel.css";
// import "owl.carousel/dist//owl.theme.default.css";

const galleryImages = [
  { src: "/images/ourfleets/1.jpg" },
  { src: "/images/ourfleets/2.jpg" },
  { src: "/images/ourfleets/3.jpg" },
  { src: "/images/ourfleets/4.jpg" },
  { src: "/images/ourfleets/5.jpg" },
  { src: "/images/ourfleets/6.jpg" },
  { src: "/images/ourfleets/7.jpg" },
  { src: "/images/ourfleets/9.jpg" },
];

const options = {
  loop: true,
  margin: 0,
  nav: false,
  dots: false,
  autoplay: true,
  autoplayTimeout: 7000,
  smartSpeed: 1800,
  responsive: {
    0: { items: 1 },
    768: { items: 3 },
    1000: { items: 5 },
  },
};

const GallerySection = () => {
  return (
    <section className="gallery-section">
      <div className="container-fluid">
        <OwlCarousel className="owl-theme" {...options}>
          {galleryImages.map((img, index) => (
            <div className="gallery-image-block" key={index}>
              <figure className="gallery-image Borderr p=2">
                <img src={img.src} alt={`Gallery ${index + 1}`} />
              </figure>
              <a
                href={img.src}
                className="lightbox-image Borderr"
                data-fancybox="gallery"
              >
                <img
                  src="/images/icons/arrowsout.png"
                  alt="Open"
                  className="-icon Borderr"
                />
              </a>
            </div>
          ))}
        </OwlCarousel>
      </div>
    </section>
  );
};

export default GallerySection;
